const URGENCY_OPTIONS = [
  { value: 4, color: "#e30000", label: "Critical" },
  { value: 3, color: "#e34d4d", label: "High" },
  { value: 2, color: "#46cf4d", label: "Normal" },
  { value: 1, color: "green", label: "Low" },
];

export { URGENCY_OPTIONS };
